import React from 'react'
import { Collapse } from 'antd'

const { Panel } = Collapse

interface IStep {
  children: JSX.Element
  title: string
}

export const Step = ({ children, title }: IStep) => {
  return (
    <Collapse
      defaultActiveKey={['1']}
      expandIcon={() => null}
      style={{ width: 564, marginBottom: 25 }}
    >
      <Panel header={title} key="1">
        {children}
      </Panel>
    </Collapse>
  )
}
